import { render, staticRenderFns } from "./OrderNewnessTable.vue?vue&type=template&id=740561d8&"
import script from "./OrderNewnessTable.vue?vue&type=script&lang=js&"
export * from "./OrderNewnessTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports